const styles = theme => ({
  root: {
    // nothing yet
  }
});

export default styles;